import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { addFollowUp, followupList } from "reduxStore/action/followUpActions";
import { useDispatch, useSelector } from "react-redux";
import { getFollowupStatus } from "reduxStore/action/masterActions";
import {
  getSiteVisitStatusData,
  updateSiteVisitStatus,
} from "reduxStore/action/siteVisitActions";
import moment from "moment";
import { handleListResponse, seo } from "utils/utils";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { leadType } from "utils/constants";

const UpdateStatusFollow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { lead_id = null, appointment_id = null } = params || {};
  const [siteVisitMapping, setSiteVisitMapping] = useState(null);
  const allFollowupDetail = useSelector((state) => state.followUp) || {};
  const followupStatus = useSelector((state) => state.followupstatus);
  const { response: res } = useSelector((state) => state.login);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    followup_status: "",
    followup_date: "",
    followup_time: "",
    remark: "",
  });

  useEffect(() => {
    if (allFollowupDetail.response) {
      const { response, addFollowupresponse = null } = allFollowupDetail;
      if (response?.status === 200) {
        setViewData(handleListResponse(response.data));
      } else {
        setViewData([]);
      }
      if (addFollowupresponse && addFollowupresponse?.status === 200) {
        // Send closing status update to LMS if mapping exists
        if (siteVisitMapping?.jv_site_visit_id) {
          const payload = {
            jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
            closingStatus: "Follow Up",
            role: res?.data?.role_title || "auto",
          };

          console.log(
            "📤 [Frontend] Sending closing status update (Follow Up)",
          );
          console.log(
            "📤 [Frontend] Payload:",
            JSON.stringify(payload, null, 2),
          );

          dispatch(updateSiteVisitStatus(payload))
            .then((res) => {
              if (res) {
                console.log("LMS notified about follow-up status");
              }
            })
            .catch((err) => {
              console.error("❌ [Frontend] Error updating LMS:", err);
            })
            .finally(() => {
              navigatpage("/followUp");
            });
        } else {
          navigatpage("/followUp");
        }
      }
    }
  }, [allFollowupDetail]);

  useEffect(() => {
    dispatch(followupList({ lead_id: lead_id }));
  }, []);

  // Fetch site visit mapping for LMS integration
  useEffect(() => {
    if (appointment_id) {
      dispatch(getSiteVisitStatusData({ appointment_id }))
        .then((res) => {
          if (res?.data?.length > 0) {
            setSiteVisitMapping(res.data[0]);
          }
        })
        .catch((err) => {
          console.error("Error fetching site visit mapping:", err);
        });
    }
  }, [appointment_id, dispatch]);

  const statusUpdate = () => {
    if (!handleValid()) {
      const post = {
        followup_status: form.followup_status,
        next_followup_date: form.next_followup_date,
        followup_time: form.followup_time,
        remark: form.remark,
        lead_id: lead_id,
        // visit_status: form.visit_status,
      };
      dispatch(addFollowUp(post));
    }
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (followup_time) => {
    if (followup_time) {
      const nextFormState = {
        ...form,
        followup_time: moment("2000-01-01 " + followup_time).format("hh:mm A"),
      };
      setForm(nextFormState);
    }
  };
  useEffect(() => {
    dispatch(getFollowupStatus());
  }, []);

  const handleValid = () => {
    let err = {};
    let formError = false;

    const currentDateTime = moment(); // Current Date and Time
    const selectedDateTime = moment(
      form.next_followup_date + " " + form.followup_time,
      "YYYY-MM-DD hh:mm A",
    );

    if (selectedDateTime.isBefore(currentDateTime, "minute")) {
      if (
        form.next_followup_date === moment().format("YYYY-MM-DD") &&
        form.followup_time
      ) {
        formError = true;
        err["followup_time"] = strings.invalidTimeError; // Custom error message for invalid time
      }
    }

    if (
      !form.next_followup_date &&
      form.followup_status == "6360c6d52ca46e9d3636fbf4"
    ) {
      formError = true;
      err["next_followup_date"] = strings.followup_dateErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }

    if (
      !form.followup_time &&
      form.followup_status == "6360c6d52ca46e9d3636fbf4"
    ) {
      formError = true;
      err["followup_time"] = strings.followup_timeErr;
    }
    if (form.followup_status === "") {
      formError = true;
      err["followup_status"] = strings.followupStatusErr;
    }

    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Update Followup Status",
      metaDescription: "Update followup status",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.newFollowup}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.NewFollowup}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.updateFollowup}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.status}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="followup_status"
                          value={form.followup_status}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectstatus}</option>
                          {followupStatus?.response ? (
                            followupStatus?.response?.data.map(
                              (item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ),
                            )
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                        {formVaild.followup_status && (
                          <span style={{ color: "red" }}>
                            {formVaild.followup_status}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.leadType}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="visit_status"
                          value={form.visit_status}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.selectType}
                          </option>
                          {leadType.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div> */}
                  {form.followup_status == "6360c6d52ca46e9d3636fbf4" && (
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.date}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="date"
                            name="next_followup_date"
                            value={form.next_followup_date}
                            onChange={handleInputField}
                            min={moment().add(1, "day").format("YYYY-MM-DD")}
                          />
                          {formVaild.next_followup_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.next_followup_date}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.time}
                            <span className="required-field"></span>
                          </label>
                          <TimePicker
                            onChange={handleInputTime}
                            value={form.followup_time}
                            type="time"
                            clockIcon={null}
                            clearIcon={null}
                            disableClock={true}
                            format={"hh:mm a"}
                            className="form-control"
                            name="followup_time"
                          />
                          {formVaild.followup_time && (
                            <span style={{ color: "red" }}>
                              {formVaild.followup_time}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild.remark && (
                          <span style={{ color: "red" }}>
                            {formVaild.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={statusUpdate}
                        >
                          {strings.update}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="class-1" />
                {viewData?.length > 0 ? (
                  viewData.map((item, index) => {
                    return (
                      <div key={index} className="card-body pt-0">
                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.followupBy} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.creator_name}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.status} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.followup_status}
                            </label>
                          </div>
                        </div>
                        <hr />
                        {/* <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.visitStatus} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.visit_status ? item.visit_status : "-"}
                            </label>
                          </div>
                        </div>
                        <hr /> */}

                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center ">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.date} & {strings.time} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center ">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.next_followup_date
                                ? `${moment(item.next_followup_date).format(
                                    "DD-MM-yyyy",
                                  )}  & 
                                    ${item.followup_time}`
                                : "-"}
                            </label>
                          </div>
                        </div>
                        <hr />

                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.description} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.remark ? item.remark : "-"}
                            </label>
                          </div>
                        </div>
                        <hr className="class-1 mb-0" />
                      </div>
                    );
                  })
                ) : (
                  <h5 className="text-center">{strings.notavailable}</h5>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdateStatusFollow;
